export default __webpack_public_path__ + "static/media/19.ecf239e1.svg";